<template>
  <div class="message-box-container">
    <TopNavbar title="客服消息"></TopNavbar>
    <div class="message-box" id="chat-box">
      <div class="rich-message" id="chat-box-v2">
        <div class="empty-chat"></div>
        <div v-for="message in messageList" :key="message.id">
          <div class="message-content message-in" v-if="message.msg_type === 1">
            <div class="avatar-box">
              <img
                  src="http://a1.wanwanshequ.com/static/public/image57e4avatar.png"/>
            </div>
            <div class="message-content-left">
              {{message.content_text}}
            </div>
          </div>

          <div class="message-content message-out" v-if="message.msg_type === 0">
            <div class="avatar-box">
              <img
                  src="http://a1.wanwanshequ.com/static/public/image57e4avatar.png"/>
            </div>
            <div class="message-content-right">
              {{message.content_text}}
            </div>
          </div>
        </div>
        <div class="empty-chat"></div>
      </div>
    </div>

    <div class="send-box-container">
      <div class="send-box">
        <div class="input-field">
          <Field v-model="inputText" placeholder="请输入内容"> </Field>
        </div>
        <Button class="send-btn" @click="onSendMessage">发送</Button>
      </div>
    </div>
  </div>
</template>

<script>
  import {Field, Toast, Button} from "vant"
  import TopNavbar from "../common/TopNavbar";

  export default {
    name: "Message",
    components: {
      TopNavbar, Field, Button
    },
    data() {
      return {
        inputText: "",
        postMessageLoading: false,
        messageList: [],
      }
    },
    mounted() {
      this.GetFeedbackData()
    },
    methods: {
      onSendMessage() {
        let params = {
          content: this.inputText,
        }
        if (this.inputText === "") {
          return
        }
        this.postMessageLoading = true
        this.$store.dispatch("PostFeedbackData", params).then(data => {
          if (data.code === 0) {
            this.inputText = ""
          } else {
            if (data.code === 20010) {
              this.$router.push("/login")
            } else {
              Toast("留言失败")
            }
          }
          this.GetFeedbackData()
          this.postMessageLoading = false
        }, () => {
          Toast("网络异常")
          this.postMessageLoading = false
        })
      },
      GetFeedbackData() {
        this.$store.dispatch("GetFeedbackData", {}).then(data => {
          if (data.code === 0) {
            this.messageList = data.data

            this.$nextTick(() => {
              let list = document.getElementById("chat-box-v2")
              console.log(list.scrollHeight)
              list.scrollTop = list.scrollHeight
              console.log(list.scrollTop)
            })
          }
        }, () => {
        })
      },
    }
  }

</script>

<style scoped lang="scss">
  .message-box-container {
  }

  .message-box {
  }

  .rich-message {
    max-height: 100vh;
    overflow: scroll;
    -ms-overflow-style: none;  /* IE and Edge */
    -webkit-tap-highlight-color: transparent;
    display: flex;
    flex-direction: column-reverse;
    padding: 0 15px;

    .empty-chat {
      width: 100%;
      min-height: 64px;
    }
  }

  .message-content {
    padding: 5px 0;
    overflow: hidden;
    overflow-x: hidden;
    overflow-y: hidden;
    position: relative;
    display: flex;

    .avatar-box {
      img {
        width: 40px;
        height: 40px;
      }
    }

    .message-content-right {
      display: flex;
      align-items: center;
      line-height: 1.2;
      margin-left: 12px;
      margin-right: 12px;
      background-color: #a0e75a;

      position: relative;
      width: auto;
      max-width: 70%;
      padding: 9px 12px;
      font-size: 16px;
      color: #333;
      border-radius: 3px;
    }

    .message-content-right::after {
      position: absolute;
      top: 10px;
      content: '';
      border: 10px solid transparent;
      border-left-color: #a0e75a;
      right: -16px;
    }

    .message-out {
    }

    .message-content-left {
      display: flex;
      align-items: center;
      line-height: 1.2;
      margin-left: 12px;
      margin-right: 12px;
      background-color: #f2f2f2;

      position: relative;
      width: auto;
      max-width: 70%;
      padding: 9px 12px;
      font-size: 16px;
      color: #333;
      border-radius: 3px;
    }

    .message-content-left::after {
      position: absolute;
      top: 10px;
      content: '';
      border: 10px solid transparent;
      border-right-color: #f2f2f2;
      left: -16px;
    }
  }

  .message-out {
    flex-direction: row-reverse;
  }

  .send-box-container {
    padding-bottom: constant(safe-area-inset-bottom);
    padding-bottom: env(safe-area-inset-bottom);
    width: 100%;
    position: fixed;
    left: 0;
    bottom: 0;
  }

  .send-box {
    background: #f4f4f4;
    padding: 5px 10px;
    display: flex;
    align-items: center;
    justify-content: center;

    .input-field {
      flex: 1 1 auto;
      padding-left: 8px;
    }
    .send-btn {
      padding: 0 15px;
      margin-left: 8px;
    }
  }
</style>
